import { Container } from "@mui/system";
import { Grid, Typography, Paper, Box, TextField, Button, LinearProgress, Avatar } from "@mui/material";
import styled from "@emotion/styled";
import FileUpload from "../components/course_edit/button_upload_file";
import React from "react";
import globals from "../globals";
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import RedButton from "../components/redButton";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BlueButton from "../components/blueButton";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingIcon from "../components/loading";
import Countdown from "../components/countdown";

const staticCourse = [
    "Уроци по математика - 7-ми клас",
    "Ива Иванова",
    "15.09.2025",
    "11:00",
    "01", // days
    "15", //hours
    "56", //mins
]

const homeworkTitle = ["tema1", "tema2", "tema3", "tema4", "tema5"]

// const materials = [
//     {
//         title: "Рационални числа и действия",
//         description: "Преговор и разширение на знанията за рационалните числа: сравняване, подреждане, абсолютна стойност и смесени операции с приоритет на действията.",
//         assignments: ["Работен лист (PDF)", "Видео", "Интерактивно"]
//     },
//     {
//         title: "Алгебрични изрази и формули ",
//         description: "Преговор и разширение на знанията за рационалните числа: сравняване, подреждане, абсолютна стойност и смесени операции с приоритет на действията.",
//         assignments: ["Работен лист (PDF)", "Видео", "Интерактивно"]
//     },
//     {
//         title: "Линейни уравнения и неравенства",
//         description: "Преговор и разширение на знанията за рационалните числа: сравняване, подреждане, абсолютна стойност и смесени операции с приоритет на действията.",
//         assignments: ["Работен лист (PDF)", "Видео", "Интерактивно"]
//     },
//     {
//         title: "Геометрия: триъгълници и окръжност",
//         description: "Преговор и разширение на знанията за рационалните числа: сравняване, подреждане, абсолютна стойност и смесени операции с приоритет на действията.",
//         assignments: ["Работен лист (PDF)", "Видео", "Интерактивно"]
//     },
// ]

const OKButton = styled(Button)(() => ({
    color: globals.colors.backgroundColor,
    backgroundColor: globals.colors.lightRed,
    '&:hover': {
        backgroundColor: globals.colors.darkRed,
        color: globals.colors.backgroundColor,
    },
    '&.Mui-selected': {
        color: globals.colors.lightRed,
    },
}))



const EnrolledCourse = ({ course }) => {
    const navigate = useNavigate();
    const { token } = useAuth();
    const { addToCart } = useCart();
    const [homeworkTopic, setHomeworkTopic] = React.useState(course.assignments[0]?.title || '');
    const [files, setFiles] = React.useState([]);
    const [comment, setComment] = React.useState('');
    const [showSubmitLoading, setShowSubmitLoading] = React.useState(false);



    const handleChangeTopic = (event) => {
        setHomeworkTopic(event.target.value);
    };

    const handleAddToCart = () => {
        addToCart({ id: course.id, title: course.title, price: course.price, instructor_name: course.instructor.first_name + " " + course.instructor.last_name });
        navigate('/cart');
    }

    const handleFilesChange = (files) => {
        setFiles(files);
    }

    const handleCommentChange = (event) => {
        setComment(event.target.value);
    }

    const handleSubmit = () => {
        setShowSubmitLoading(true);
        const formData = new FormData();
        formData.append('data', JSON.stringify({ comment: comment }));
        files.forEach(file => {
            formData.append('files', file);
        });

        const homeworkId = course.assignments.filter(assignment => assignment.title == homeworkTopic)[0].id;


        fetch(globals.apiUrl + `/courses/assignments/${course.id}/${homeworkId}`, {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': `Bearer ${token}`,
                // 'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                setShowSubmitLoading(false);
            })
            .catch(error => {
                console.error('Error:', error);
                setShowSubmitLoading(false);
            })
            .finally(() => {
                setShowSubmitLoading(false);
            });
    }

    return (
        <Container>
            <Grid container direction={'column'}>
                <Grid item>
                    <Typography sx={{ color: globals.colors.lightRed, fontSize: 25, fontWeight: 'bold' }}>{course.title}</Typography>
                </Grid>
                <Grid item>
                    <Typography sx={{ color: globals.colors.darkBlue, mt: 2 }}>Преподавател: <strong>{course.instructor.first_name} {course.instructor.last_name}</strong></Typography>
                </Grid>
            </Grid>

            <Grid container sx={{ mt: 1 }} spacing={3}>
                <Grid item xs={12} sm={6}>
                    <Paper sx={{ p: 2 }} elevation={4}>
                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 22 }}>Следващ урок</Typography>
                        <Grid container justifyContent={'space-between'}>
                            <Grid item>
                                <Grid container sx={{ mt: 2 }}>
                                    <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 18 }}>Дата:</Typography>
                                    <Typography sx={{ color: globals.colors.lightRed, fontWeight: 'bold', fontSize: 18, ml: 1 }}>{(course.next_meeting) ? new Date(course.next_meeting.from_time).toLocaleDateString('bg-BG') : ''}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container sx={{ mt: 2 }}>
                                    <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 18 }}>Час:</Typography>
                                    <Typography sx={{ color: globals.colors.lightRed, fontWeight: 'bold', fontSize: 18, ml: 1, mr: 10 }}>{(course.next_meeting) ? new Date(course.next_meeting.from_time).toLocaleTimeString('bg-BG') : ''}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 22, mt: 4 }}><AccessAlarmIcon sx={{ fontSize: 25, color: globals.colors.lightRed, mb: -0.6, mr: 1 }} />Започва след:</Typography>
       
                        <Grid container spacing={4} justifyContent={'center'}>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.lightRed, fontWeight: 'bold', fontSize: 25, mt: 2 }}><Countdown  targetDate={course.next_meeting ? course.next_meeting.from_time : new Date()}/></Typography>
                            </Grid>
                            <Grid item>
                                <RedButton disabled={!course.next_meeting} text="Включи се" mTop={2} pX={2} href={(course.next_meeting) ? course.next_meeting.zoom_link : '#'} />
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item sx={{ mt: 3 }}>
                                <PriorityHighIcon sx={{ color: globals.colors.lightRed }} />
                            </Grid>
                            <Grid item sm={11} xs={11}>
                                <Typography sx={{ mt: 3, fontSize: 10 }}>Ако {" "}
                                    <Box component="span" sx={{ color: globals.colors.lightRed, fontWeight: 'bold' }}>
                                        НЕ
                                    </Box>{" "} можеш да присъстваш, предупреди учителя 24 часа
                                    преди началото на урока!
                                    В противен случай - урокът ти ще бъде таксуван!</Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>


                <Grid item xs={12} sm={6}>
                    <Paper sx={{ p: 2 }} elevation={4}>
                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 22 }}>Качи домашната си работа </Typography>

                        <Grid justifyContent={'center'} alignContent={'center'} textAlign={'center'}>
                            <FormControl sx={{
                                width: '30vw',
                                '& .MuiInputLabel-root.Mui-focused': {
                                    color: globals.colors.darkRed, // focused label color
                                },
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: globals.colors.darkRed, // default border
                                    },
                                    '&:hover fieldset': {
                                        borderColor: globals.colors.darkRed, // hover
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: globals.colors.darkRed, // focused
                                    },
                                }, mt: 1
                            }}>
                                <InputLabel id="demo-simple-select-label">Тема</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    // value={course.assignments[0]?.title || ''}
                                    disabled={course.assignments.length === 0}
                                    value={homeworkTopic}
                                    label="Тема"
                                    onChange={handleChangeTopic}
                                    sx={{
                                        backgroundColor: globals.colors.backgroundColor,
                                        borderRadius: 1,
                                        color: globals.colors.textColor,

                                    }}
                                >
                                    {course.assignments.map(({ title }, i) => (
                                        <MenuItem value={title} key={i}>{title}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <TextField id="title" disabled={course.assignments.length === 0} label="Коментар към домашно" variant="outlined" sx={{
                                backgroundColor: globals.colors.backgroundColor,
                                borderRadius: 1,
                                color: globals.colors.textColor,
                                '& .MuiInputLabel-root.Mui-focused': {
                                    color: globals.colors.darkRed, // focused label color
                                },
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: globals.colors.darkRed, // default border color
                                    },
                                    '&:hover fieldset': {
                                        borderColor: globals.colors.darkRed, // border color on hover
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: globals.colors.darkRed, // border color when focused
                                    },
                                }, width: '30vw', mt: 1, mb: 1,
                            }}
                                onChange={handleCommentChange}
                                value={comment}
                            />
                            <FileUpload disabled={course.assignments.length === 0} helpText={'Прикачи файл'} id={'multi-file-upload-'} onChange={handleFilesChange} />
                        </Grid>
                        <Grid container justifyContent={'end'} alignItems={'end'} textAlign={'end'} sx={{ mr: 3 }}>
                            {showSubmitLoading && <LoadingIcon sx={{mr:1}}/>}
                            <OKButton disabled={course.assignments.length === 0} sx={{ mr: 3, textTransform: 'none' }} onClick={handleSubmit}>Изпрати</OKButton>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid >


            <Grid container sx={{ mt: 3 }}>
                <Grid item sm={12}>
                    <Paper sx={{ p: 2, }} elevation={4}>
                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 22 }}>Оставащи платени уроци </Typography>
                        <Grid container justifyContent={'flex-end'}>
                            <Grid item >
                                <Typography sx={{ fontWeight: 'bold', fontSize: 17, color: globals.colors.gray }}>
                                    {course.reserved_lessons_amount - course.reserved_lessons_used_amount} / {course.reserved_lessons_amount}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <LinearProgress
                                    variant="determinate"
                                    value={((course.reserved_lessons_amount - course.reserved_lessons_used_amount) / course.reserved_lessons_amount) * 100}
                                    sx={{
                                        borderRadius: 5,
                                        backgroundColor: globals.colors.backgroundColor,
                                        '& .MuiLinearProgress-bar': {
                                            backgroundColor: globals.colors.lightRed, // Bar color
                                        }, mt: 3
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={3}>
                            <Grid item>
                                <RedButton text='Добави още' mTop={4} pX={2} onClick={() => {
                                    handleAddToCart();
                                }} />
                            </Grid>
                            <Grid item>
                                <BlueButton text="Към моя профил" mTop={4} pX={2} href='/dashboard' />
                            </Grid>
                        </Grid>

                    </Paper>
                </Grid>

                <Grid container sx={{ mt: 3 }}>
                    <Grid item sm={12}>
                        <Paper elevation={4} sx={{ p: 2 }}>
                            <Typography sx={{ color: globals.colors.lightRed, fontWeight: 'bold', fontSize: 22 }}>Учебни материали от преподавателя </Typography>
                            <Grid container justifyContent={'center'} sx={{ mt: 3 }}>
                                <Grid item sm={12} xs={12}>
                                    {course.assignments.map((material) => (
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <Typography sx={{ fontSize: 17, color: globals.colors.darkBlue, fontWeight: 'bold' }}>{material.title}</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Typography sx={{ color: globals.colors.gray, fontSize: 16 }} dangerouslySetInnerHTML={{ __html: material.description }}></Typography>
                                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 16, fontWeight: 'bold', mt: 2 }}>Материали</Typography>
                                                {
                                                    material.materials.map(assignment => (
                                                        <ul>
                                                            <li>
                                                                {assignment}
                                                            </li>
                                                        </ul>
                                                    ))
                                                }
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>

                <Grid container sx={{ mt: 4 }}>
                    <Grid item sm={12}>
                        <Paper elevation={4} sx={{ p: 3 }}>
                            <Grid container justifyContent={'space-around'}>
                                <Grid item>
                                    <Avatar sx={{ width: 50, height: 50 }} src={course.instructor.image_url} />
                                </Grid>
                                <Grid item>
                                    <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', fontSize: 17, mt: 2 }}>При възникнали въпроси, свързани с учебния материал, пиши на преподавателя.</Typography>
                                </Grid>
                                <Grid item>
                                    <RedButton text='Към чата' mTop={1} pX={5} href={`/chat/${course.chat_id}`} />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
        </Container >
    );
}

export default EnrolledCourse;